/* ===== 8-oct: filtros y categorías sin recargar ni saltar al inicio ===== */
(function(){
  var busy=false;
  function root(){return document.querySelector('[data-nv-ajax],.nvk');}
  function sameShop(u){return u.origin===location.origin&&/^\/collections\//.test(u.pathname);}
  function openState(r){return {side:!!(r.querySelector('[data-nvk-side]')||{}).open,acc:[].map.call(r.querySelectorAll('.nvk-acc'),function(d){return d.open;})};}
  async function go(url,push){
    var r=root();if(!r||busy)return;busy=true;r.classList.add('is-loading');
    var st=openState(r),y=window.scrollY,cs=r.querySelector('.nvk-cats');var cx=cs?cs.scrollLeft:0;
    try{
      var res=await fetch(url,{headers:{'Accept':'text/html'}});var html=await res.text();
      var doc=new DOMParser().parseFromString(html,'text/html');var nr=doc.querySelector('[data-nv-ajax],.nvk');
      if(!nr){location.href=url;return;}
      r.innerHTML=nr.innerHTML;
      if(window.matchMedia('(min-width:750px)').matches||st.side){var sd=r.querySelector('[data-nvk-side]');if(sd)sd.open=true;}
      r.querySelectorAll('.nvk-acc').forEach(function(d,i){if(st.acc[i])d.open=true;});
      var ncs=r.querySelector('.nvk-cats');if(ncs)ncs.scrollLeft=cx;
      if(doc.title)document.title=doc.title;
      if(push)history.pushState({nv:1},'',url);
      window.scrollTo(0,y);
      if(window.nvNums)window.nvNums(r);
    }catch(e){location.href=url;}
    finally{busy=false;var rr=root();if(rr)rr.classList.remove('is-loading');}
  }
  document.addEventListener('click',function(e){
    var r=root();if(!r)return;var a=e.target.closest('a[href]');if(!a||!r.contains(a))return;
    if(a.closest('.nvc')||a.target==='_blank'||e.metaKey||e.ctrlKey||e.shiftKey)return;
    var u=new URL(a.href,location.href);if(!sameShop(u))return;
    e.preventDefault();go(u.toString(),true);
  });
  document.addEventListener('change',function(e){
    var s=e.target.closest('[data-nvk-sort],.nvk-sort select');if(!s||!root())return;e.stopImmediatePropagation();
    var u=new URL(location.href);u.searchParams.set('sort_by',s.value);u.searchParams.delete('page');go(u.toString(),true);
  },true);
  document.addEventListener('submit',function(e){
    var f=e.target.closest('.nvk-price');if(!f||!root())return;e.preventDefault();
    var u=new URL(f.action,location.href);new FormData(f).forEach(function(v,k){if(v!=='')u.searchParams.set(k,v);});go(u.toString(),true);
  });
  window.addEventListener('popstate',function(){if(root())go(location.href,false);});
})();
/* ===== 8-oct: números en seminegrita en títulos ===== */
(function(){
  var SEL='.nv h1,.nv h2,.nv h3,.nvc__t,.nvp-t,.nvp-rut__i b,.nvh-cc__txt b,.nvq h2,.nvq h3';
  function wrap(scope){(scope||document).querySelectorAll(SEL).forEach(function(el){
    if(el.dataset.nvn)return;el.dataset.nvn='1';
    var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT),n,list=[];while(n=w.nextNode()){if(/\d/.test(n.nodeValue)&&!n.parentNode.closest('.nv-num'))list.push(n);}
    list.forEach(function(t){var f=document.createDocumentFragment();t.nodeValue.split(/(\d[\d.,+%×x]*)/).forEach(function(p,i){if(!p)return;if(i%2){var s=document.createElement('span');s.className='nv-num';s.textContent=p;f.appendChild(s);}else f.appendChild(document.createTextNode(p));});t.parentNode.replaceChild(f,t);});
  });}
  window.nvNums=wrap;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){wrap();});else wrap();
})();
